import { render, staticRenderFns } from "./GotchaView.vue?vue&type=template&id=2362bca6&scoped=true"
import script from "./GotchaView.vue?vue&type=script&lang=ts"
export * from "./GotchaView.vue?vue&type=script&lang=ts"
import style0 from "./GotchaView.vue?vue&type=style&index=0&id=2362bca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362bca6",
  null
  
)

export default component.exports